import {useState} from 'react';

export const useLocalState = () => {
  const [loading, setLoading] = useState(false);

  return {loading, setLoading};
};
